import React, { FC } from 'react'
import * as UI from './ProductCounterStyled'
import Product from '../../../api/models/Product'
import Cart from '../../../api/models/Cart'
import * as actions from '../../../actions/cart'

import { useDispatch, useSelector } from 'react-redux'

interface TProps {
  product: Product
}

const ProductCounter: FC<TProps> = ({ product, ...rest }) => {
  const dispatch = useDispatch()

  const cart = useSelector((state: { cart: Cart }) => new Cart(state.cart))
  const productInCart = cart.getProduct(product._id)?.count || 0

  const addButtonActive = !product.isEnabledStock() || product.stock_quantity > productInCart

  const availabilityMessage = {
    SoldOut: 'Nothing left. Sold out',
    LimitedAvailability: `Only ${product.stock_quantity} left`,
    InStock: ''
  }

  return (
    <>
      <p className="d-inline">Buy</p>
      <UI.ProductCounter {...rest}>
        <button disabled={!productInCart} onClick={() => dispatch(actions.removeProduct(product))}>
          <div className="minus"></div>
        </button>
        <input value={productInCart} />
        <button disabled={!addButtonActive} onClick={() => dispatch(actions.addProduct(product))}>
          <div className="plus"></div>
        </button>
        <p>{availabilityMessage[product.getAvailability()]}</p>
      </UI.ProductCounter>
    </>
  )
}

export { ProductCounter }
